import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { ReactComponent as UploadedFile } from "../../../../assets/uploaded-file-gov.svg";
import { ReactComponent as UploadedFileError } from "../../../../assets/uploaded-file-error.svg";
import { ReactComponent as Bin } from "../../../../assets/bin.svg";
import { ReactComponent as ConfirmIcon } from "../../../../assets/waiting-for-approval.svg";
import { ReactComponent as Download } from "../../../../assets/download_blue.svg";
import { ReactComponent as Locked } from "../../../../assets/lock.svg";
import { ReactComponent as UnLocked } from "../../../../assets/unlock.svg";
import { ReactComponent as GreenSuccess } from "../../../../assets/success.svg";
import "./file.css";
import {
  Tooltip,
  Modal,
  Progress,
  Select,
  Button,
} from "antd";
import {
  downloadDocument,
  updatePermissions
} from "../../../../store/documents/actions";
import {
  renderOptions,
  renderUserTags
} from "../../../../util/basicRenders";
const File = ({
  error,
  file,
  fileName,
  handleDeleteDocument,
  percent,
  id,
  parent_id,
  organization,
  user
}) => {
  //use user authentication hook to get the user object (dpo user in this case)
  // console.debug("File.js: user: ", user);
  const [tooltipVisible, setTooltipVisible] = useState("");
  const users = useSelector(state => state.organizations?.usersData);
  const isVisible = tooltipVisible === "file-name-hover";
  const onVisibleChange = v => setTooltipVisible(v ? "file-name-hover" : "");
  const [openModal, setOpenModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [permitted, setPermitted] = useState(
    file?.userPermissions?.length ? [...file?.userPermissions] : []
  );
  const loading = useSelector(state => state.documents?.loading);

  const userIsOwner = user?.userId === file?.user_id
  const fileisPublic = isEmpty(file?.userPermissions)
  const accessAllowed =
    userIsOwner ||
    fileisPublic ||
    file?.userPermissions?.includes(user?.userId);

  const { confirm } = Modal;
  const dispatchito = useDispatch();
  const deleteConfirm = (event, file) => {
    confirm({
      title: "Delete Confirmation",
      icon: <ConfirmIcon />,
      content: `Are you sure you want to delete this file?`,
      okText: "Confirm",
      cancelText: "Close",
      onOk() {
        handleDeleteDocument(event, file);
      },
    });
  };

  const addUser = value => {
    // console.debug({ value });
    // console.debug({ permitted });
    // console.debug(file?.userPermissions);
    if (Array.isArray(permitted) && !permitted?.includes(value)) {
      setPermitted(permitted.length ? [...permitted, value] : [value]);
    }
    setSearchValue("");
  };

  const removePermission = userId => {
    console.debug({ userId });
    const newPermitted = permitted.filter(user => user !== userId);
    console.debug({ newPermitted });
    setPermitted(newPermitted);
  };

  return (
    <div
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();
      }}
      className={`custom-drag__uploading-progress ${
        error && "custom-drag__uploading-error"
      }`}
    >
      <div className="d-flex justify-content-between">
        <div className="d-flex w-100">
          {error ? <UploadedFileError /> : <UploadedFile />}
          <div className="w-100 file-details-container">
            {error ? (
              <div className="file-error">
                <div>{file.description}</div>
                {file.fileLimit && (
                  <div>The max file size is {file.fileLimit}MB.</div>
                )}
                <span>{file.name}</span>
              </div>
            ) : (
              <>
                <Tooltip
                  key={file.id}
                  title={
                    fileName
                      ? fileName
                      : typeof file == "object"
                      ? file.name
                      : file
                  }
                  open={isVisible}
                  onOpenChange={onVisibleChange}
                >
                  <div className="filename">
                    {fileName
                      ? fileName
                      : typeof file == "object"
                      ? file.name
                      : file}
                  </div>
                </Tooltip>
                {/* <div className="filesize">
                  {Math.round(file.size / 1000)} KB
                </div> */}
                <div className="d-flex">
                  <Progress percent={percent || 100} showInfo={false} />
                  <div className="ml-1 file-percent">{percent || 100}%</div>
                </div>
              </>
            )}
          </div>
        </div>
        <div id="file-action-icons">
          <Download
            style={{ visibility: accessAllowed ? "visible" : "hidden" }}
            onClick={e => {
              e.stopPropagation();
              dispatchito(
                downloadDocument({
                  docId: file?.doc_id,
                  user,
                  callback: (
                    linkSource = "",
                    filename = "downloaded-file.pdf"
                  ) => {
                    console.debug({ linkSource });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = linkSource;
                    downloadLink.download = filename; //without this it just opens it in browser instead of downloading it
                    document.body.appendChild(downloadLink); // Required for Firefox
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                  }
                })
              );
            }}
            className="download-file"
          />
          {user?.role &&
            user?.role !== "corporateComplianceObserver" &&
            user?.role !== "groupComplianceObserver" && (
              <Bin
                onClick={event => deleteConfirm(event, file)}
                color={error ? "#B42318" : "#667085"}
                style={{ visibility: accessAllowed ? "visible" : "hidden" }}
                className="remove-file"
              />
            )}
          <Tooltip
            title={"Restricted Access"}
            arrow={false}
            overlayClassName="lock-tooltip"
            mouseEnterDelay={0.5}
            placement="topLeft"
          >
            <UnLocked
              onClick={event => {
                if (userIsOwner && !loading) {
                  setPermitted([]);
                  setOpenModal(true);
                }
              }}
              style={{
                display: fileisPublic ? "inline" : "none"
              }}
              className="lock-file"
            />{" "}
          </Tooltip>

          <Tooltip
            title={"Restricted Access"}
            arrow={false}
            overlayClassName="lock-tooltip"
            mouseEnterDelay={0.5}
            placement="topLeft"
          >
            <Locked
              onClick={event => {
                if (userIsOwner && !loading) {
                  setPermitted([...file.userPermissions]);
                  setOpenModal(true);
                }
              }}
              className="lock-file"
              style={{
                display: !fileisPublic ? "inline" : "none"
              }}
            />
          </Tooltip>
        </div>
      </div>
      <Modal
        style={{ top: 200 }}
        open={openModal}
        onOk={() => setOpenModal(false)}
        closable={false}
        footer={null}
        className="confidentiality-modal"
      >
        <div className="image_modal">
          <GreenSuccess />
        </div>
        <div className="modal_info">
          <h3>Select User</h3>
        </div>
        <div className="modal_inputs">
          <div className="modal-info">
            Select the user(s) that you want to have restricted access to this
            file.
          </div>
          <Select
            virtual={false}
            className="input-filter userSelect"
            style={{ width: "100%" }}
            disabled={false}
            showSearch
            onSearch={setSearchValue}
            allowClear={false}
            value={""}
            placeholder="Search User"
            optionFilterProp="children"
            onChange={value => {
              setSearchValue("");
              addUser(value);
            }}
            filterOption={false}
          >
            {renderOptions(searchValue, users)}
          </Select>
          {!isEmpty(permitted) && (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {renderUserTags(
                permitted,
                users,
                "#F2F4F7",
                "#344054",
                true,
                "Revoke Permission",
                removePermission
              )}
            </div>
          )}
        </div>
        <div className="modal-buttons-wrapper">
          <Button
            onClick={() => {
              // setPermitted([]);
              setOpenModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className="confirm-btn"
            onClick={() => {
              dispatchito(
                updatePermissions(user, organization, file._id, permitted)
              );
              // setPermitted([]);
              setOpenModal(false);
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default File;
